import React from 'react'
import { View, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'
import { Icon } from '@vfgroup-oneplatform/foundation/Components'

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../VfText'

import styles from './RowItem.Styles'

function RowItem(props) {

    const {
        icon,
        iconType,
        leftComponent,
        title,
        titlePlaceholders,
        desc,
        descPlaceholders,
        iconStyle,
        titleStyle,
        descStyle,
        topText,
        topTextPlaceholders,
        topContent,
        bottomText,
        bottomTextPlaceholders,
        bottomContent,
        style,
        rightIcon,
        rightIconType,
        rightIconStyle,
        rightComponent,
        rightIconPress
    } = props

    const theme = useTheme()

    let propStyles
    if (iconType !== 'image') {
        propStyles = Object.assign({}, { tintColor: theme.colors.textColorThree }, iconStyle)
    } else {
        propStyles = iconStyle
    }
    let rightIconPropStyles
    if (rightIconType !== 'image') {
        rightIconPropStyles = Object.assign({}, { tintColor: theme.colors.textColorThree }, rightIconStyle)
    } else {
        rightIconPropStyles = rightIconStyle
    }

    return (
        <View style={style}>
            {Boolean(topText) && <VfText
                placeHolders={topTextPlaceholders}
                i18nKey={topText}
                color={theme.colors.smoothGrey}
            /> || topContent}
            <View style={styles.container}>
                {icon && <Icon
                    name={icon}
                    size={24}
                    type="image"
                    resizeMode="contain"
                    style={[styles.icon, propStyles]}
                />}
                {leftComponent && (
                    <View style={styles.leftComponent}>
                        {leftComponent}
                    </View>
                )}
                <View style={styles.textContaner}>
                    {Boolean(title) && (
                        <VfText
                            style={[styles.title(theme), titleStyle]}
                            placeHolders={titlePlaceholders}
                            i18nKey={title || ''}
                        />
                    )}
                    {Boolean(desc) && (
                        <VfText
                            size="footnote"
                            style={[styles.desc(theme), descStyle]}
                            placeHolders={descPlaceholders}
                            i18nKey={desc}
                        />
                    )}
                </View>
                {rightIcon && <TouchableOpacity onPress={rightIconPress} disabled={!rightIconPress}>
                    <Icon
                        name={rightIcon}
                        size={24}
                        type="image"
                        resizeMode="contain"
                        style={[styles.icon, rightIconPropStyles]}
                    />
                </TouchableOpacity>}
                {rightComponent && (
                    <View style={styles.rightComponent}>
                        {rightComponent}
                    </View>
                )}
            </View>
            {Boolean(bottomText) && <VfText
                i18nKey={bottomText}
                placeHolders={bottomTextPlaceholders}
                style={styles.bottomText(theme)}
                color={theme.colors.textColorTwo}
            /> || bottomContent}
        </View>
    )
}

RowItem.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.objectOf({ uri: PropTypes.string.isRequired })
    ]),
    iconType: PropTypes.string,
    leftComponent: PropTypes.any,
    title: PropTypes.string,
    desc: PropTypes.string,
    iconStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    titleStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    descStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    topText: PropTypes.string,
    topContent: PropTypes.any,
    bottomText: PropTypes.string,
    bottomContent: PropTypes.any,
    style: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),

    rightIcon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.objectOf({ uri: PropTypes.string.isRequired })
    ]),
    rightComponent: PropTypes.any,
    rightIconType: PropTypes.string,
    rightIconStyle: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    rightIconPress: PropTypes.func
}

export default RowItem
